import { Component, ElementRef, ViewChild, inject } from "@angular/core";
import { KriWidgetType } from "@app/dashboard/shared/enums/KriWidgetType.enum";
import { Pages } from "@constants/pages/Pages";
import { ComparisonType } from "@enums/workspace/ComparisonType";
import { SearchKeyword } from "@models/workspace/SearchKeyword";
import { KriDataService } from "../../../../kri/services/kri-data.service";
import { WidgetFilterKey } from "./../../../shared/models/WidgetFilterKey";
import { BaseHighchartWidget } from "./../BaseHighchartWidget";
import { firstValueFrom } from "rxjs";
import { provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/dashboard/i18n/scope";

@Component({
    selector: "kri-widget",
    templateUrl: "../highchart-widget.component.html",
    styleUrls: ["../highchart-widget.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
})
export class KriWidgetComponent extends BaseHighchartWidget {
    @ViewChild("chartContainer") chartContainer: ElementRef;

    private kriDataService = inject(KriDataService);
    private pages = inject(Pages);

    constructor() {
        super();

        this.globalFilterWorkspaceColumns[WidgetFilterKey.GlobalFilter.Organization] =
            "organizationIds";
        this.globalFilterWorkspaceColumns[WidgetFilterKey.GlobalFilter.BusinessDimension] =
            "businessDimensionIds";
        this.globalFilterWorkspaceColumns[WidgetFilterKey.GlobalFilter.FrameworkDimension] =
            "frameworkDimensionIds";
    }

    protected async getChartConfig() {
        await this.translation.ready();

        const filters = this.getFilters();
        const data = await firstValueFrom(this.kriDataService.getWidgetInfo(filters));

        this.config.noData = !data || data.length === 0;
        if (this.config.noData) {
            return null;
        }

        const mappedData = [
            <any>{
                name: this.translation.t("kriWidget.seriesName"),
                data,
            },
        ];

        const config = this.getBaseChartConfig(null, mappedData);

        config.tooltip = {
            headerFormat: "<b>{point.key}:</b> {point.y}",
            pointFormat: "",
        };

        config.chart.spacingLeft = 0;
        config.chart.spacingRight = 0;

        config.plotOptions.pie.size = "65%";
        config.plotOptions.pie.innerSize = "50%";

        return config;
    }

    protected async openWorkspace(ev) {
        const widgettype = this.getFilter(WidgetFilterKey.Kri.KriType);

        const searchKeywords: SearchKeyword[] = [
            this.getSearchKeyword("aggregateScore", ev.point.name, ComparisonType.Contains),
        ];

        if (widgettype == KriWidgetType.Kri) {
            searchKeywords.push(
                this.getSearchKeyword("kriKpi", "No", ComparisonType["Is equal to"]),
            );
        } else if (widgettype == KriWidgetType.Kpi) {
            searchKeywords.push(
                this.getSearchKeyword("kriKpi", "Yes", ComparisonType["Is equal to"]),
            );
        }

        const preset = await this.getBasePreset(searchKeywords);
        this.openPreset(this.pages.KriOverview, preset);
    }

    protected async onGlobalOpenClick() {
        const preset = await this.getBasePreset();
        this.openPreset(this.pages.KriOverview, preset);
    }
}
